<template lang="pug">
v-card.custom-card(outlined, style="position: relative")
  v-progress-linear.clientes-loading-bar(
    v-if="carregando",
    indeterminate,
    color="blue",
    height="2"
  )
  v-card-title.custom-card-title.d-flex.align-center.justify-space-between.ma-0
    .d-flex.align-center.gap-2
      span {{ titulo }}
    v-spacer
    v-spacer
    //- Filtro por Softhouse
    v-menu(offset-y, close-on-content-click=false, :disabled="filtrosDesabilitados")
      template(v-slot:activator="{ on, attrs, value }")
        v-chip.filter-badge-chip(
          v-bind="attrs",
          v-on="on",
          x-small,
          outlined,
          :disabled="filtrosDesabilitados",
          :class="{ 'filter-badge-chip--active': softhouseFiltro }",
          close,
          @click:close="$emit('update:softhouse-filtro', null)"
        )
          | {{ labelSofthouse }}
          v-icon(x-small, right) {{ value ? "mdi-chevron-up" : "mdi-chevron-down" }}
      v-list(dense, style="max-height: 280px; overflow-y: auto")
        v-list-item(
          v-for="opcao in softhouseOpcoes",
          :key="opcao",
          @click="$emit('toggle-softhouse-filtro', opcao)"
        )
          v-list-item-title.text-body-2(
            :class="{ 'primary--text': softhouseFiltro === opcao }"
          ) {{ opcao }}
    //- Filtro por Status do Cliente
    v-menu(offset-y, close-on-content-click=false, :disabled="filtrosDesabilitados")
      template(v-slot:activator="{ on, attrs, value }")
        v-chip.ml-1.filter-badge-chip(
          v-bind="attrs",
          v-on="on",
          x-small,
          outlined,
          :disabled="filtrosDesabilitados",
          :class="{ 'filter-badge-chip--active': statusbaseFiltro !== null }",
          close,
          @click:close="$emit('update:statusbase-filtro', null)"
        )
          | {{ labelStatus }}
          v-icon(x-small, right) {{ value ? "mdi-chevron-up" : "mdi-chevron-down" }}
      v-list(dense)
        v-list-item(
          v-for="opcao in statusbaseOpcoes",
          :key="opcao.value",
          @click="$emit('toggle-statusbase-filtro', opcao.value)"
        )
          v-list-item-title.text-body-2(
            :class="{ 'primary--text': statusbaseFiltro === opcao.value }"
          ) {{ opcao.text }}
    v-badge.clientes-badge(
      :content="contagemExibida === null ? '' : String(contagemExibida)",
      :value="contagemExibida !== null",
      color="blue",
      inline
    )
  v-card-text.custom-card-body
    //- Campo de busca
    .card-search
      v-text-field.preview-field(
        :value="busca",
        @input="$emit('update:busca', $event)",
        prepend-inner-icon="mdi-magnify",
        :placeholder="placeholderBusca",
        clearable,
        hide-details,
        filled,
        rounded,
        dense
      )
    //- Lista de clientes
    .clientes-lista(:class="{ 'clientes-lista--vazia': listaVazia }")
      //- Mensagem quando nenhuma persona está selecionada
      .empty-persona-message.text-center.py-8(v-if="filtrosDesabilitados")
        v-icon.empty-state-icon(size="48", color="blue lighten-3") mdi-account-group-outline
        .empty-state-title.mt-3 {{ textoSemPersonaTitulo }}
        .empty-state-subtitle.mt-1 {{ textoSemPersonaSubtitulo }}

      //- Carregando
      template(v-else-if="carregando")
        .empty-state-loading.text-center.py-8
          v-progress-circular(indeterminate, color="blue")
          .empty-state-title.mt-3 {{ textoCarregando }}

      //- Sem resultados
      template(v-else-if="itens.length === 0")
        .empty-state-no-results.text-center.py-8
          v-icon.empty-state-icon(size="48", color="blue lighten-3") mdi-account-off-outline
          .empty-state-title.mt-3 {{ textoVazio }}

      //- Lista
      template(v-else)
        .cliente-item(
          v-for="cliente in itens",
          :key="cliente.idcliente",
          :class="{ selecionado: selecionado && selecionado.idcliente === cliente.idcliente }",
          @click="$emit('select', cliente)"
        )
          .cliente-icon-wrapper
            v-icon.cliente-icon(small, color="blue lighten-1") mdi-domain
            v-tooltip(bottom)
              template(v-slot:activator="{ on, attrs }")
                v-icon.cliente-status-icon(
                  v-bind="attrs",
                  v-on="on",
                  :color="cliente.statusserver ? 'success' : 'error'",
                  size="10"
                ) mdi-circle
              span {{ cliente.statusserver ? "Conectado ao socket" : "Desconectado do socket" }}
          .cliente-info
            .cliente-nome(:title="cliente.nome") {{ cliente.nome }}
            .d-flex.align-center.gap-1.mt-1
              //- Uma linha só: a caracterização encolhe com reticências; o "+N", a versão e o contador não
              .cliente-meta.d-flex.align-center.gap-1.mt-1
                v-chip.persona-badge.persona-badge--principal(
                  x-small,
                  outlined,
                  v-if="personaDoCliente(cliente)",
                  :title="outrasPersonasDoCliente(cliente).length > 0 ? todasPersonasDoCliente(cliente).join(', ') : personaDoCliente(cliente)"
                )
                  span.persona-texto {{ personaDoCliente(cliente) }}
                  span.persona-mais(v-if="outrasPersonasDoCliente(cliente).length > 0") +{{ outrasPersonasDoCliente(cliente).length }}
                v-chip.persona-badge.persona-badge--fixo(x-small, outlined, v-if="cliente.versaobase") {{ cliente.versaobase }}
              v-spacer
              v-chip.empresa-count-badge(
                x-small,
                color="blue lighten-4",
                text-color="blue darken-3"
              )
                v-icon.ml-1(x-small, left) mdi-domain
                | {{ cliente.empresas ? cliente.empresas.length : 0 }}
</template>

<script>
export default {
  name: "ClientesCard",

  props: {
    titulo: {
      type: String,
      default: "Clientes"
    },
    itens: {
      type: Array,
      default: () => []
    },
    personas: {
      type: Array,
      default: () => []
    },
    carregando: {
      type: Boolean,
      default: false
    },
    selecionado: {
      type: Object,
      default: null
    },
    busca: {
      type: String,
      default: ""
    },
    placeholderBusca: {
      type: String,
      default: "Pesquisar por cliente ou hash"
    },
    filtrosDesabilitados: {
      type: Boolean,
      default: false
    },
    labelSofthouse: {
      type: String,
      default: "Softhouse"
    },
    softhouseOpcoes: {
      type: Array,
      default: () => []
    },
    softhouseFiltro: {
      type: String,
      default: null
    },
    labelStatus: {
      type: String,
      default: "Status"
    },
    statusbaseOpcoes: {
      type: Array,
      default: () => []
    },
    statusbaseFiltro: {
      type: Number,
      default: null
    },
    textoSemPersonaTitulo: {
      type: String,
      default: "Selecione uma caracterização"
    },
    textoSemPersonaSubtitulo: {
      type: String,
      default: "Selecione uma ou mais caracterizações acima para visualizar os clientes"
    },
    textoCarregando: {
      type: String,
      default: "Carregando clientes..."
    },
    textoVazio: {
      type: String,
      default: "Nenhum cliente encontrado"
    }
  },

  data() {
    return {
      // Total mostrado na bolinha. Só muda quando o carregamento termina, para não passar
      // por 0 (lista zerada pela tela) antes do valor final. null = ainda sem total.
      contagemExibida: null
    };
  },

  watch: {
    contagemAtual: {
      immediate: true,
      handler() {
        this.atualizarContagem();
      }
    },
    carregando() {
      this.atualizarContagem();
    }
  },

  computed: {
    // Total real: sem caracterização selecionada a lista fica escondida, então é 0.
    contagemAtual() {
      return this.filtrosDesabilitados ? 0 : this.itens.length;
    },

    // Os estados vazios ocupam a altura toda para ficarem centrados; a lista
    // preenchida mantém o alinhamento ao topo por causa do scroll.
    listaVazia() {
      return this.filtrosDesabilitados || this.carregando || this.itens.length === 0;
    }
  },

  methods: {
    // Congela o total enquanto carrega; ao terminar, vai direto do valor antigo ao novo.
    atualizarContagem() {
      if (this.carregando) return;
      this.contagemExibida = this.contagemAtual;
    },

    personaDoCliente(cliente) {
      if (!cliente || !cliente.empresas || cliente.empresas.length === 0) return "—";
      const tipos = [...new Set(cliente.empresas.map(e => e.tipoempresa))];
      if (tipos.length === 0) return "—";
      const persona = this.personas.find(p => p.tipoempresa === tipos[0]);
      return persona ? persona.tipo_empresa : "—";
    },

    // Nomes de todas as caracterizações distintas do cliente (usado no title do chip).
    todasPersonasDoCliente(cliente) {
      return [this.personaDoCliente(cliente), ...this.outrasPersonasDoCliente(cliente)];
    },

    // Nomes das demais caracterizações do cliente (todas menos a primeira, já exibida).
    outrasPersonasDoCliente(cliente) {
      if (!cliente || !cliente.empresas || cliente.empresas.length === 0) return [];
      const tipos = [...new Set(cliente.empresas.map(e => e.tipoempresa))];
      return tipos.slice(1).map(tipo => {
        const persona = this.personas.find(p => p.tipoempresa === tipo);
        return persona ? persona.tipo_empresa : "—";
      });
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.custom-card-title {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  background-color: #e3f2fd;
  border-radius: 18px 6px 0 0;
}

.custom-card-body {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 12px 18px 16px !important;
}

.gap-2 {
  gap: 8px;
}

.clientes-badge .v-badge__badge {
  font-size: 11px;
  font-weight: 700;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
}

.card-search {
  flex: 0 0 auto;
  padding-bottom: 12px;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input,
.preview-field .v-select__selection {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__slot {
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}

.clientes-lista {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 2px 4px;
}

/* Centraliza verticalmente o loader e os estados vazios */
.clientes-lista--vazia {
  justify-content: center;
}

.cliente-item {
  display: flex;
  align-items: flex-start;
  padding: 10px 12px;
  border: 1px solid #e8eef4;
  border-radius: 8px;
  background-color: #fff;
  transition: all 0.15s ease;
  gap: 8px;
  cursor: pointer;
}

.cliente-item:hover {
  background-color: #edf4fc;
  border-color: #b3d4fc;
}

.cliente-item.selecionado {
  background-color: #e3f2fd;
  border-color: #1976d2;
  box-shadow: 0 0 0 1px #1976d2;
}

.cliente-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.cliente-icon-wrapper {
  position: relative;
  margin-top: 2px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cliente-status-icon {
  position: absolute;
  right: -3px;
  bottom: -1px;
  border: 1.5px solid #fff;
  border-radius: 50%;
  background-color: #fff;
}

.cliente-info {
  flex: 1;
  min-width: 0;
}

/* No máximo 3 linhas; o nome completo fica no title */
.cliente-nome {
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

/* Linha de chips sem quebra; só a caracterização encolhe */
.cliente-meta {
  flex: 0 1 auto;
  min-width: 0;
  flex-wrap: nowrap;
  gap: 4px;
}

.persona-badge {
  font-weight: 600;
  font-size: 10px !important;
  height: 18px !important;
  border-color: #9e9e9e !important;
  color: #616161 !important;
}

.persona-badge--principal {
  min-width: 0;
  flex: 0 1 auto;
}

.persona-badge--fixo {
  flex: 0 0 auto;
}

.persona-texto {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.persona-mais {
  flex-shrink: 0;
  margin-left: 4px;
}

.empresa-count-badge {
  flex: 0 0 auto;
  font-weight: 700;
  font-size: 10px !important;
  height: 18px !important;
  padding: 0 8px !important;
  margin-left: 4px;
}

.empresa-count-badge .v-icon--left {
  margin-right: 4px;
}

.filter-badge-chip {
  display: inline-flex !important;
  align-items: center !important;
  line-height: 1 !important;
  border-color: #b0bec5 !important;
  color: #546e7a !important;
  font-weight: 500 !important;
  font-size: 11px !important;
  border-radius: 16px !important;
  transition: all 0.15s ease !important;
  cursor: pointer !important;
  height: 24px !important;
}

.filter-badge-chip .v-chip__content {
  align-items: center !important;
  height: 100% !important;
}

.filter-badge-chip:hover {
  background-color: #e3f2fd !important;
  border-color: #1976d2 !important;
  color: #1976d2 !important;
}

.filter-badge-chip.v-chip--disabled {
  opacity: 0.5 !important;
  cursor: default !important;
  pointer-events: none !important;
}

.filter-badge-chip--active {
  border-color: #1976d2 !important;
  color: #1976d2 !important;
  background-color: #e3f2fd !important;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.empty-state-loading,
.empty-state-no-results {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-persona-message {
  padding: 40px 20px;
}

.empty-persona-message .empty-state-icon {
  opacity: 0.5;
}

.empty-persona-message .empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #616161;
}

.empty-persona-message .empty-state-subtitle {
  font-size: 12px;
  color: #9e9e9e;
}

.clientes-loading-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 4px 4px 0 0;
}
</style>
